// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const LOAD_ERROR_MESSAGE = "Nepoda\u0159ilo se na\u010d\u00edst obsah";
export const LOAD_ERROR_RETRY = "Zkus to znovu";
